<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-toolbar
            id="core-toolbar"

            flat
            prominent
            style="background: white;"
    >
        <!--    <div class="v-toolbar-title">-->
        <!--      <v-toolbar-title-->
        <!--        class="tertiary&#45;&#45;text font-weight-light"-->
        <!--      >-->
        <!--        <v-btn-->
        <!--          v-if="responsive"-->
        <!--          class="default v-btn&#45;&#45;simple"-->
        <!--          dark-->
        <!--          icon-->
        <!--          @click.stop="onClickBtn"-->
        <!--        >-->
        <!--          <v-icon>mdi-view-list</v-icon>-->
        <!--        </v-btn>-->
        <!--        {{ title }}-->
        <!--      </v-toolbar-title>-->
        <!--    </div>-->


        <!--    <v-menu-->
        <!--            bottom-->
        <!--            left-->
        <!--            content-class="dropdown-menu"-->
        <!--            offset-y-->
        <!--            transition="slide-y-transition"-->
        <!--            open-on-hover>-->
        <!--      <router-link-->
        <!--              v-ripple-->
        <!--              slot="activator"-->
        <!--              class="toolbar-items"-->
        <!--              to="/notifications"-->
        <!--      >-->
        <!--&lt;!&ndash;        <v-badge&ndash;&gt;-->
        <!--&lt;!&ndash;                color="error"&ndash;&gt;-->
        <!--&lt;!&ndash;                overlap&ndash;&gt;-->
        <!--&lt;!&ndash;        >&ndash;&gt;-->
        <!--&lt;!&ndash;          <template slot="badge">&ndash;&gt;-->
        <!--&lt;!&ndash;            {{ notifications.length }}&ndash;&gt;-->
        <!--&lt;!&ndash;          </template>&ndash;&gt;-->
        <!--          <div style="background-color: #1a237e; height: 70px; ">-->
        <!--              <span style="vertical-align:middle; display: table-cell;">-->
        <!--              주차장 관리-->
        <!--              </span>-->
        <!--          </div>-->
        <!--&lt;!&ndash;        </v-badge>&ndash;&gt;-->
        <!--      </router-link>-->
        <!--&lt;!&ndash;      <v-card>&ndash;&gt;-->
        <!--      <div style="background-color: #eee; height: 80px; ">-->
        <!--      </div>-->
        <!--&lt;!&ndash;      <v-list style="background-color: #0d47a1; box-sizing: unset;">&ndash;&gt;-->
        <!--&lt;!&ndash;        <v-list-tile&ndash;&gt;-->
        <!--&lt;!&ndash;                v-for="notification in notifications"&ndash;&gt;-->
        <!--&lt;!&ndash;                :key="notification"&ndash;&gt;-->
        <!--&lt;!&ndash;                @click="onClick"&ndash;&gt;-->
        <!--&lt;!&ndash;        >&ndash;&gt;-->
        <!--&lt;!&ndash;          <v-list-tile-title&ndash;&gt;-->
        <!--&lt;!&ndash;                  v-text="notification"&ndash;&gt;-->
        <!--&lt;!&ndash;          />&ndash;&gt;-->
        <!--&lt;!&ndash;        </v-list-tile>&ndash;&gt;-->
        <!--&lt;!&ndash;      </v-list>&ndash;&gt;-->
        <!--&lt;!&ndash;      </v-card>&ndash;&gt;-->
        <!--    </v-menu>-->

        <v-menu
                content-class="dropdown-menu"
                offset-y
                transition="slide-y-transition"
                v-for="link in links"
                v-bind:key="link.to"
                open-on-hover
        >
            <router-link
                    v-ripple
                    slot="activator"
                    class="toolbar-items"
                    :to="link.to" >
                <div style="width: 200px; height: 70px; ">
                    <div
                            style="position: relative;
                          top: 50%;
                          left: 50%;
                          -moz-transform: translateX(-50%) translateY(-50%);
                          -webkit-transform: translateX(-50%) translateY(-50%);
                          transform: translateX(-50%) translateY(-50%);
                          text-align: center;">
                        <a class="asdqwe" >
                            {{ link.text }}
                        </a>
                    </div>
                </div>
            </router-link>
            <div style="background-color: #eee; display: inline-block; padding: 0px 20px 20px;" v-if="link.sublinks.length > 0">
                <div v-for="sublink in link.sublinks" :to="sublink.to" >
                    <router-link
                            slot="activator"
                            class="toolbar-items"
                            :to="sublink.to"
                            v-show="!sublink.dontshow"
                    >
                        <!--                      <div style="width: 150px; height: 70px; ">-->
                        <!--                          <div-->
                        <!--                                  style="position: relative;-->
                        <!--                          top: 50%;-->
                        <!--                          left: 50%;-->
                        <!--    -moz-transform: translateX(-50%) translateY(-50%);-->
                        <!--    -webkit-transform: translateX(-50%) translateY(-50%);-->
                        <!--    transform: translateX(-50%) translateY(-50%);-->
                        <!--text-align: center;">-->
                        <a class="asdqwe" >
                            {{ sublink.text }}
                        </a>
                        <!--                      </div>-->
                        <!--                      </div>-->
                    </router-link>
                </div>
            </div>
            <!--      <v-list style="background-color: #0d47a1; box-sizing: unset;">-->
            <!--        <v-list-tile-->
            <!--                v-for="notification in notifications"-->
            <!--                :key="notification"-->
            <!--                @click="onClick"-->
            <!--        >-->
            <!--          <v-list-tile-title-->
            <!--                  v-text="notification"-->
            <!--          />-->
            <!--        </v-list-tile>-->
            <!--      </v-list>-->
            <!--      </v-card>-->
            <router-link
                    v-ripple
                    slot="activator"
                    class="toolbar-items"
                    to="/accountmanage">
                <div style="width: 200px; height: 70px; "
                     v-show="tool_app.isAdmin()">
                    <div
                            style="position: relative;
                          top: 50%;
                          left: 50%;
                          -moz-transform: translateX(-50%) translateY(-50%);
                          -webkit-transform: translateX(-50%) translateY(-50%);
                          transform: translateX(-50%) translateY(-50%);
                          text-align: center;">
                        <a class="asdqwe" >
                            계정 관리
                        </a>
                    </div>
                </div>
            </router-link>
        </v-menu>

        <!--    <div class="text-xs-center">-->
        <!--      <v-menu offset-y-->
        <!--              content-class="dropdown-menu"-->
        <!--              open-on-hover>-->
        <!--          <v-btn-->
        <!--                  color="primary"-->
        <!--                  dark-->
        <!--          >-->
        <!--            Dropdown-->
        <!--          </v-btn>-->
        <!--        <v-list >-->
        <!--          <v-list-tile-->
        <!--                  v-for="notification in notifications"-->
        <!--                  :key="notification"-->
        <!--                  @click="onClick"-->
        <!--          >-->
        <!--            <v-list-tile-title-->
        <!--                    v-text="notification"-->
        <!--            />-->
        <!--          </v-list-tile>-->
        <!--        </v-list>-->
        <!--      </v-menu>-->
        <!--    </div>-->
        <v-spacer />
        <v-toolbar-items>
            <v-flex
                    align-center
                    layout
                    py-2
            >
                <!--        <v-text-field-->
                <!--          v-if="responsiveInput"-->
                <!--          class="mr-4 mt-2 purple-input"-->
                <!--          label="Search..."-->
                <!--          hide-details-->
                <!--          color="purple"-->
                <!--        />-->
                <!--        <router-link-->
                <!--          v-ripple-->
                <!--          class="toolbar-items"-->
                <!--          to="/"-->
                <!--        >-->
                <!--          <v-icon color="tertiary">mdi-view-dashboard</v-icon>-->
                <!--        </router-link>-->
                <!--        <v-menu-->
                <!--          bottom-->
                <!--          left-->
                <!--          content-class="dropdown-menu"-->
                <!--          offset-y-->
                <!--          transition="slide-y-transition">-->
                <!--          <router-link-->
                <!--            v-ripple-->
                <!--            slot="activator"-->
                <!--            class="toolbar-items"-->
                <!--            to="/notifications"-->
                <!--          >-->
                <!--            <v-badge-->
                <!--              color="error"-->
                <!--              overlap-->
                <!--            >-->
                <!--              <template slot="badge">-->
                <!--                {{ notifications.length }}-->
                <!--              </template>-->
                <!--              <v-icon color="tertiary">mdi-bell</v-icon>-->
                <!--            </v-badge>-->
                <!--          </router-link>-->
                <!--          <v-card>-->
                <!--            <v-list dense>-->
                <!--              <v-list-tile-->
                <!--                v-for="notification in notifications"-->
                <!--                :key="notification"-->
                <!--                @click="onClick"-->
                <!--              >-->
                <!--                <v-list-tile-title-->
                <!--                  v-text="notification"-->
                <!--                />-->
                <!--              </v-list-tile>-->
                <!--            </v-list>-->
                <!--          </v-card>-->
                <!--        </v-menu>-->


                <v-menu open-on-hover bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <!--                  <v-btn-->
                        <!--                          color="primary"-->
                        <!--                          dark-->
                        <!--                          v-on="on"-->
                        <!--                  >-->
                        <!--                      Dropdown-->
                        <!--                  </v-btn>-->
                        <v-btn
                                flat
                                v-ripple
                                v-on="on"
                        >
                            <v-icon color="tertiary">mdi-account</v-icon>
                        </v-btn>
                    </template>
                    <!--              <template v-slot:activator="{ asd }">-->
                    <!--                                <router-link-->
                    <!--                                        v-ripple-->
                    <!--                                        class="toolbar-items"-->
                    <!--                                        to="/accountmanage"-->
                    <!--                                        v-on="asd"-->
                    <!--                                        >-->
                    <!--                                    <v-icon color="tertiary">mdi-account</v-icon>-->
                    <!--                                </router-link>-->
                    <!--                                    </template>-->

                    <v-list>
                        <v-list-tile
                                @click="
                                edit_item = {};
                                $refs.edit_form.reset();
                                $refs.edit_form.resetValidation();
                                edit_dialog = true"
                        >
                            <v-list-tile-title>비밀번호 변경</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                                @click="signout()"
                        >
                            <v-list-tile-title>로그아웃</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>

                <!--          <v-menu-->
                <!--                  content-class="dropdown-menu"-->
                <!--                  offset-y-->
                <!--                  transition="slide-y-transition"-->
                <!--                  open-on-hover-->
                <!--                  style="width: 100px; height: 100px;"-->
                <!--                  :key="1"-->
                <!--          >-->
                <!--              <router-link-->
                <!--                      v-ripple-->
                <!--                      class="toolbar-items"-->
                <!--                      to="/dashboard"-->
                <!--              >-->
                <!--                  <v-icon color="tertiary">mdi-account</v-icon>-->
                <!--              </router-link>-->
                <!--          </v-menu>-->

                <!--        <router-link-->
                <!--          v-ripple-->
                <!--          class="toolbar-items"-->
                <!--          to="/dashboard"-->
                <!--        >-->
                <!--          <v-icon color="tertiary">mdi-account</v-icon>-->
                <!--        </router-link>-->
            </v-flex>
        </v-toolbar-items>
            <v-dialog v-model="edit_dialog" persistent max-width="600px">
                <v-card>
                    <v-card-text>
                        <span style="font-weight: bold; font-size: 17px;" >비밀번호 변경</span>
                        <v-container grid-list-md>
                            <v-form ref="edit_form"
                                    v-model="edit_valid"
                                    lazy-validation>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-text-field label="이전 비밀번호"
                                                      :type="'password'"
                                                      v-model="edit_item.OldPassword"
                                                      :rules="edit_password_rules"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field label="새 비밀번호"
                                                      :type="'password'"
                                                      v-model="edit_item.NewPassword"
                                                      :rules="edit_password_rules"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="edit_dialog = false">취소</v-btn>
                        <v-btn color="blue darken-1" flat @click="change_password()">변경하기</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    </v-toolbar>

</template>

<script>

    import {
        mapMutations
    } from 'vuex'

    import tool_app from '../../utils/tool_app';
    import eventbus from '../../utils/eventbus';
    import tool_aws from '../../utils/tool_aws';
    import {Auth, } from 'aws-amplify'

    function lg (...args) { tool_app.lg('CoreToolbar] ', ...args); }

    let comp;
    export default {
        data: () => ({
            notifications: [
                'Mike, John responded to your email',
                'You have 5 new tasks',
                'You\'re now a friend with Andrew',
                'Another Notification',
                'Another One'
            ],
            links: [
                // {
                //     to: '/icons',
                //     icon: 'mdi-map-marker',
                //     text: '아이콘',
                //     sublinks: [],
                // },
                {
                    to: '/valetreservation',
                    icon: 'mdi-map-marker',
                    text: 'VIP 발렛 예약',
                    sublinks: [],
                },
                // {
                //     to: '/parkinglotmanage',
                //     icon: 'mdi-map-marker',
                //     text: '주차장 관리',
                //     sublinks: [],
                // },
                // {
                //     to: '/periodiccarmanage/0',
                //     icon: 'mdi-map-marker',
                //     text: '정기차량 관리',
                //     sublinks: [
                //         {
                //             to: '/periodiccar_allparkinglot',
                //             icon: 'mdi-map-marker',
                //             text: '정기 차량 관리 - 전체 주차장 현황',
                //             dontshow: true,
                //         },
                //         {
                //             to: '/periodiccarmanage/0',
                //             icon: 'mdi-map-marker',
                //             text: '현재 등록 차량',
                //         },
                //         {
                //             to: '/periodiccarstandbymanage',
                //             icon: 'mdi-map-marker',
                //             text: '등록 대기 차량',
                //         },
                //         // {
                //         //   to: '/periodiccarmanage',
                //         //   icon: 'mdi-map-marker',
                //         //   text: '정기차량 정보3',
                //         // },
                //         // {
                //         //   to: '/accountmanage',
                //         //   icon: 'mdi-map-marker',
                //         //   text: '정기차량 정보4',
                //         // },
                //     ],
                // },
                // {
                //   to: '/accountmanage',
                //   icon: 'mdi-map-marker',
                //   text: '계정 관리',
                //   sublinks: [],
                // },
                // {
                //   to: '/dashboard',
                //   icon: 'mdi-view-dashboard',
                //   text: 'Dashboard',
                //   sublinks: [],
                // },
            ],

            edit_dialog: false,
            edit_valid: false,
            edit_user: {},
            edit_item: {},
            edit_password_rules: [
                v => !!(v)  || '입력해주세요..',
                v => !!(v && v.length >= 6) || '6자 이상 입력해주세요',
            ],
        }),

        watch: {
            '$route' (val) {
                // console.log('Toolbar watch $route val:',val);
                this.title = val.name
            }
        },

        created() {
            comp = tool_app.initComp(this);
            lg('created 1 tool_app.isSignedIn:', tool_app.isSignedIn());
            // 총괄관리자인 경우
            eventbus.$on(eventbus.Events.Signed, comp.checkMenu);
            comp.checkMenu();
        },
        mounted () {
            this.onResponsiveInverted()
            window.addEventListener('resize', this.onResponsiveInverted)
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.onResponsiveInverted)
        },

        methods: {
            ...mapMutations('app', ['setDrawer', 'toggleDrawer']),

            async checkMenu(payload) {
                lg('checkMenu 2 ', tool_app.isSignedIn());
                if(tool_app.isSignedIn()) {
                    let session = await tool_aws.getCurrentSession();
                    if(session.idToken.payload['custom:permission'] === '총괄관리자') {
                        comp.links.forEach((value, index, array) => {
                            value.sublinks.forEach((value2, index, array) => {
                                if (value2.to === '/periodiccar_allparkinglot') {
                                    value2.dontshow = false;
                                }
                            });
                        });
                    }
                    else {
                        comp.links.forEach((value, index, array) => {
                            value.sublinks.forEach((value, index, array) => {
                                if (value.to === '/periodiccar_allparkinglot') {
                                    value.dontshow = true;
                                }
                            });
                        });
                    }
                }
            },
            onClickBtn () {
                this.setDrawer(!this.$store.state.app.drawer)
            },
            onClick () {
                //
            },
            onResponsiveInverted () {
                if (window.innerWidth < 991) {
                    this.responsive = true
                    this.responsiveInput = false
                } else {
                    this.responsive = false
                    this.responsiveInput = true
                }
            },
            signout () {
                Auth.signOut()
                    .then(data => {
                        console.log(data)
                    })
                    .catch(err => console.log(err))
            },
            async change_password() {
                lg('change_password 1 '+comp.$refs.edit_form.validate());
                if ((comp.edit_dialog && comp.$refs.edit_form.validate() === false)) {
                    return;
                }


                Auth.currentAuthenticatedUser()
                    .then((user) => {
                        return Auth.changePassword(user, comp.edit_item.OldPassword, comp.edit_item.NewPassword);
                    })
                    .then((data) => {
                        lg(data);
                        if(data === 'SUCCESS') {
                            comp.edit_dialog = false;
                            comp.$dialog.alert('비밀번호가 정상적으로 변경되었습니다.');
                        }
                    })
                    .catch((reason) => {
                        tool_app.ex(reason);
                        // comp.$dialog.alert(JSON.stringify(reason, null, 2));
                        if(reason.message === 'Attempt limit exceeded, please try after some time.') {
                            comp.$dialog.alert('제한횟수가 초과되었습니다. 잠시 후 재시도 해주세요.');
                        }
                        else {
                            comp.$dialog.alert('비밀번호가 일치하지 않습니다');
                        }
                    });

//                 // let d = comp.$dialog.confirm(item.Username + '의 비밀번호를 초기화 하시겠습니까?');
//                 // let session = tool_aws.getCurrentSession();
//                 Auth.changePassword(session, comp.edit_item.OldPassword, comp.edit_item.NewPassword)
//                     .then(async (data) => {
// lg('change_password 9 data:', data);
//                     })
//                     .catch(async (reason) => {
//                         tool_app.ex(reason);
//                         this.$dialog.alert(JSON.stringify(reason, null, 2));
//                     });
                // d.then(async (dialog) => {
                //     tool_app.dialog_progress_show(comp);
                //     let cognito = await tool_aws.getAdminCognito();
                //     let params = {
                //         UserPoolId: awsmobile.aws_user_pools_id,
                //         Username: item.Username,
                //         Password: '111111',
                //         Permanent: false,
                //     };
                //     cognito.cha(params, (err, data) => {
                //         if(err) {
                //             tool_app.ex(err);
                //             return;
                //         }
                //         tool_app.lg('account_dialog_passwordreset 2 response:', JSON.stringify(data, null, 2));
                //         tool_app.dialog_progress_hide(comp);
                //     });
                // });
            },
        }
    }
</script>

<style>
    /*#core-toolbar a {*/
    /*  text-decoration: none;*/
    /*}*/
    a.asdqwe  {
        text-transform: uppercase;
        text-decoration: none;
        letter-spacing: 0.15em;
        color: #333; text-align: center; font-size: 15px; font-weight: bold;

        display: inline-block;
        padding: 15px 20px;
        position: relative;
    }
    a.asdqwe:after {
        background: none repeat scroll 0 0 transparent;
        bottom: 0;
        content: "";
        display: block;
        height: 2px;
        left: 50%;
        position: absolute;
        background: #333;
        transition: width 0.3s ease 0s, left 0.3s ease 0s;
        width: 0;
    }
    a.asdqwe:hover:after {
        width: 100%;
        left: 0;
    }
</style>
